import {DefaultNodeTypes} from "@payloadcms/richtext-lexical";
import {JSXConvertersFunction, LinkJSXConverter} from "@payloadcms/richtext-lexical/react";
import {internalDocToHref} from "@/components/content/common/RichText/Converters/internalLink";
import {headingConverter} from "@/components/content/common/RichText/Converters/headingConverter";
import {paragraphConverter} from "@/components/content/common/RichText/Converters/paragraphConverter";

type NodeTypes = DefaultNodeTypes;

export const createJSXConverter = (theme?: "light" | "dark"): JSXConvertersFunction<NodeTypes> => ({ defaultConverters }) => ({
    ...defaultConverters,
    ...LinkJSXConverter({ internalDocToHref }),
    ...headingConverter(theme),
    ...paragraphConverter,
    blocks: {},
});